"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var audioApi_1 = require("@cdo/apps/lib/util/audioApi");
var songs_1 = require("@cdo/apps/dance/songs");
var Button_1 = __importDefault(require("@cdo/apps/templates/Button"));
var song_selector_module_scss_1 = __importDefault(require("@cdo/apps/dance/song-selector.module.scss"));
var commonI18n = require('@cdo/locale');
var currentTimeoutsMap = {};
var songPreviewDurationInMs = 10000;
var SongSelector = function (_a) {
    var selectedSong = _a.selectedSong, levelIsRunning = _a.levelIsRunning, setSong = _a.setSong, songData = _a.songData, enableSongSelection = _a.enableSongSelection, filterOn = _a.filterOn;
    var _b = (0, react_1.useState)(false), songInPreview = _b[0], setSongInPreview = _b[1];
    var onPreviewBtnClick = (0, react_1.useCallback)(function () {
        if (songInPreview) {
            audioApi_1.commands.stopSound({ url: songData[selectedSong].url });
        }
        else {
            audioApi_1.commands.playSound({
                url: "".concat(songData[selectedSong].url),
                callback: function () {
                    setSongInPreview(true);
                    var timeoutID = setTimeout(function () {
                        if (!levelIsRunning) {
                            audioApi_1.commands.stopSound({ url: songData[selectedSong].url });
                        }
                    }, songPreviewDurationInMs);
                    currentTimeoutsMap[selectedSong] = timeoutID;
                },
                onEnded: function () {
                    currentTimeoutsMap[selectedSong] &&
                        clearTimeout(currentTimeoutsMap[selectedSong]);
                    delete currentTimeoutsMap[selectedSong];
                    setSongInPreview(false);
                },
            });
        }
    }, [levelIsRunning, selectedSong, songData, songInPreview]);
    var songKeys = (0, songs_1.getFilteredSongKeys)(songData, filterOn);
    // When you change the song - unloadSong is triggered in apps/src/dance/songs.js. (which unloads and stops the current song)
    // When song is stopped - audioCommands.playSound onEnded callback is triggered where we set setSongInPreview(false).
    var changeSong = (0, react_1.useCallback)(function (event) {
        var songId = event.target.value;
        setSong(songId);
    }, [setSong]);
    return (react_1.default.createElement("div", { id: "song-selector-wrapper", className: song_selector_module_scss_1.default.songSelectorWrapper },
        react_1.default.createElement("label", null,
            react_1.default.createElement("b", null, commonI18n.selectSong())),
        react_1.default.createElement("select", { id: "song_selector", className: song_selector_module_scss_1.default.selectStyle, onChange: changeSong, value: selectedSong, disabled: !enableSongSelection }, songKeys.map(function (option, i) { return (react_1.default.createElement("option", { key: i, value: option }, songData[option].title)); })),
        react_1.default.createElement(Button_1.default, { type: "button", className: (0, classnames_1.default)(song_selector_module_scss_1.default.previewSongButton, !levelIsRunning && songInPreview && song_selector_module_scss_1.default.previewActiveButton), disabled: levelIsRunning, color: Button_1.default.ButtonColor.neutralDark, icon: " fa-solid fa-play-pause", onClick: onPreviewBtnClick })));
};
exports.default = SongSelector;
